import { AppConfig } from '@aipb/env/util';
import { DynamicGalleryEnv } from './dynamic-gallery.env';

export class DynamicGalleryConfig extends AppConfig<DynamicGalleryEnv> {
  get apiUrl(): string {
    // @ts-expect-error foo
    return this.config.apiUrl;
  }

  get defaultImage(): string {
    return this.config.defaultImage || 'https://via.placeholder.com/350x250';
  }
}
